import Dispatcher from "events-dispatch";
import { triggerEvent } from "../../../services/helpers/trigger-event";

const filtersEvents = {
  "change": "filter.events.change",
  "reset": "filter.events.reset",
}

class Filters {
  constructor(form) {
    new Dispatcher(this);

    this.form = form; 
    this.form.addEventListener("change", (e) => {
      this._onChange();
    });
    this.form.addEventListener("submit", (e) => {
      e.preventDefault();
    })
  }

  get needUpdateForm() {
    return this.form.hasAttribute('data-update-form');
  }

  get needUpdateUrl() {
    return this.form.hasAttribute('data-update-url');
  }

  get el() {
    return this.form;
  }

  get searchParams() {
    return new URLSearchParams(this.getData()).toString();
  }

  _onChange() {
    this.trigger(filtersEvents.change);
  }

  getData() {
    return new FormData(this.form);
  }

  reset(silent) {
    this.form.clear();

    if (!silent) {
      this._onChange();
    }
  }

  update(filterObject) {
    if (this.needUpdateForm) {
      for (let fieldName in filterObject) {
        let element = this.form.elements[fieldName];
        if (element) {
          element.value = filterObject[fieldName];
          triggerEvent(element, "setValue");
        }
      }
    }
    
  }
}

export default Filters;